import React from "react";
import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    Outlet,
} from "react-router-dom";

// Import the components
import "../src/Locates/locate";
import { useAuth } from "./Provider/Auth/AuthProvider";
import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ClientList from "./Pages/Clients/ClientList";
import ClientCad from "./Pages/Clients/ClientCad";
import NotFound from "./Pages/NotFound/NotFound";
import ToastAlert from "./Provider/Alert/ToastAlert";
import Users from "./Pages/Users/Users";
import UserActivation from "./Pages/Users/UserActivation";
import UserForgot from "./Pages/Users/UserForgot";
import UserRecovery from "./Pages/Users/UserRecovery";
import { ThemeProvider } from "./Provider/Theme/themeContext";
import { ConfigProvider } from "./Provider/Config/config";
import { SidebarProvider } from "./Hook/useSidebar";

// Defining private routes
const PrivateRoute = () => {
    const { auth } = useAuth();
    return auth ? (
        <ConfigProvider>
            <SidebarProvider>
                <Outlet />
            </SidebarProvider>
        </ConfigProvider>
    ) : (
        <Navigate to="/login" />
    );
};

function App() {
    return (
        <BrowserRouter basename="/primusimport">
            <ToastAlert />
            <ThemeProvider>
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/verification-user"
                        element={<UserActivation />}
                    />
                    <Route path="/forgot-password" element={<UserForgot />} />
                    <Route path="/recovery" element={<UserRecovery />} />
                    <Route path="/" element={<PrivateRoute />}>
                        <Route index element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/client" element={<ClientList />}></Route>
                        <Route path="/client/:id" element={<ClientCad />} />
                        <Route path="/client/create" element={<ClientCad />} />
                        <Route path="/users" element={<Users />} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/login" />} />
                </Routes>
            </ThemeProvider>
        </BrowserRouter>
    );
}

export default App;
